module.exports = __webpack_public_path__ + "static/media/pdf.91ac9bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pdf.jpg
// module id = 278
// module chunks = 2